import React from "react";
import Helpers from "../../../helpers/helperFunctions";
import Sport from "../sport";
import Favorit from "./pieces/favorit";
import Loader from "../loader";
import Config from "../../../config/main";
import GameNotFound from "../gameNotFound";
import { Link } from "react-router";
import { t } from "../../../helpers/translator";

export default function sportsListTemplate() {
	const { sportsCount, loaded, gameType, selectorKey, sportAlias, isAsian, timeFilter } = this.props;

	if (sportsCount && loaded) {
		let Sports = [];
		for (let i = 0; i < sportsCount; i++) {
			Sports.push(
				<Sport
					key={i}
					selectorKey={selectorKey}
					index={i}
					sportAlias={sportAlias}
					gameType={gameType}
				/>
			);
		}
		const hideScrollButtons = sportsCount <= 9;

		return (
			<div
				className={
					"sports-navigation" +
					(loaded ? " loading" : "") +
					(Helpers.isPC() ? " isPC" : "") +
					(hideScrollButtons ? " hide-scroll-buttons" : "")
				}
			>
				{Helpers.isPC() ? (
					<button
						className="sports-navigation-scroll-buttons left-button"
						onMouseDown={() => {
							this.handleMouseUp();
							this.scroll(this.refs.scroller, -3, 17);
						}}
					/>
				) : null}
				<div className="sport-nav-container-m" ref="scroller">
					<div className="sport-nav-list">
						{!this.props.isAsian && Config.enableFavoritesGame && (
							<Favorit gameType={gameType} />
						)}
						{gameType === "topGames" ||
							(Config.enableAllSectionInLive && gameType === "live" && (
								<Link
									className={`${
										sportAlias === "all" && "active"
									}`}
									to={`/${this.props.gameType}/all/all`}
								>
									<span className={"sport-icon-m all"}></span>
									<p>All</p>
								</Link>
							))}
						{/* ToDO After boostedodds section for standart */}
						{Config.enablePredefinedMultiples &&
							(gameType === "today" ||
								(Config.enableMultiplesForPrematch &&
									timeFilter === 0) ||
								timeFilter === -1) && (
								<Link
									className={`${
										sportAlias === "multiples" && "active"
									}`}
									to={`/${this.props.gameType}/multiples`}
								>
									<span
										className={"sport-icon-m multiples"}
									></span>
									<p>{t(`Multiples of the day`)}</p>
								</Link>
							)}
						{Config.betting.enableBetBuilderSection && gameType === "prematch" && (
							<Link
								className={`${sportAlias === "betBuilder" && "active"}`}
								to={`/${this.props.gameType}/betBuilder/all/all`}
							>
								<span
									className={
										"bet-builder-icon global-icon icon-bet-builder"
									}
								></span>
								<p>{t(`Bet Builder`)}</p>
							</Link>
						)}
						{Config.enableBoostedOdds &&
							Object.keys(this.props.boostedOddsGameIds).length > 0 &&
							gameType === "prematch" && (
								<Link
									className={`${
										sportAlias === "boosted" && "active"
									}`}
									to={`/${this.props.gameType}/boosted/all/all`}
								>
									<i className="global-icon icon-boosted" />
									<p>{t(`Boosted Odds`)}</p>
								</Link>
							)}
						{Sports}
					</div>
				</div>
				{Helpers.isPC() ? (
					<button
						className="sports-navigation-scroll-buttons right-button cms-jcon-lc-right"
						onMouseDown={() => {
							this.handleMouseUp();
							this.scroll(this.refs.scroller, 3, 17);
						}}
					/>
				) : null}
			</div>
		);
	} else if (sportsCount === 0 && loaded) {
		return <GameNotFound />;
	} else {
		return <Loader component="sportsList" />;
	}
}
